/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('cargoParameterCtrl', cargoParameterCtrl)
        .controller('newEditCargoParameterCtrl', newEditCargoParameterCtrl)
        .controller('deleteCargoParameterCtrl', deleteCargoParameterCtrl);

    cargoParameterCtrl.$inject = ['linkService', 'cargoParameters'];

    newEditCargoParameterCtrl.$inject = ['cargoParameterService', 'linkService', 'cargoParameter','action'];

    deleteCargoParameterCtrl.$inject = ['cargoParameter', 'cargoParameterService', '$uibModalInstance','linkService'];

    function cargoParameterCtrl(linkService, cargoParameters){
        var vm = this;

        vm.cargoParameters = (cargoParameters.data._embedded) ? cargoParameters.data._embedded.parameters : [];
        vm.linkService = linkService;
    }

    function newEditCargoParameterCtrl(cargoParameterService, linkService, cargoParameter, action){
        var vm = this;
        vm.linkService = linkService;
        vm.cargoParameter = {
            "name": "air.cargoParameter.constantVolumetric"
        };

        if(action == 'edit'){
            vm.cargoParameter.lang = cargoParameter.data.lang;
            vm.cargoParameter.priority = cargoParameter.data.priority;
            vm.cargoParameter.cargoParameterId = vm.linkService.getLinkId(cargoParameter.data._links.self.href);
        }

        vm.save = function(isValid, cargoParameter){
            if (isValid) {
                cargoParameter.active = true;
                cargoParameter.baseTariff = false;
                if(action == "new"){
                    cargoParameterService.saveCargoParameter(cargoParameter);
                }else{
                    cargoParameterService.updateCargoParameter(vm.cargoParameter.cargoParameterId, vm.cargoParameter)
                }
            }
        }
    }

    function deleteCargoParameterCtrl(cargoParameter, cargoParameterService, $uibModalInstance,linkService){
        var vm = this;
        vm.cargoParameter = cargoParameter.data;

        vm.delete = function(){
            cargoParameterService.deleteCargoParameter(linkService.getLinkId(cargoParameter.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
